export class ErrorLog {
    exceptionType: string;
    exceptionMessage: string;
    stackTrace: string;
    location: string;
}